/**
 * @Author: v_jppjpeng
 * @Date: 2024-05-29 10:07:00
 * @Explain: 联系人 - 注册表单
 */
import type { HttpResponse } from '@/api/data.d';
import http from '../http';

const MODEL = '/signup_form';
export default {
  // 列表
  getList(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/list_form`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 详情
  getDetails(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/get_form`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedValueKey: JSON.stringify(['attributes_default_value','attributesDefaultValue']),
      },
    });
  },
  // 获取最后一次opt-in配置
  getLastOptInConfig(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/get_optin_last_config`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 查看报表
  getReport(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/get_form_stats`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 新增
  onAdd(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/add_form`, data, {
      params: {
        switchReqToUnderline: true, // 忽略 attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        ignoreConvertedValueKey: JSON.stringify(['attributes_default_value','attributesDefaultValue']),
      },
    });
  },
  // 编辑
  onEdit(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/update_form`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        ignoreConvertedValueKey: JSON.stringify(['attributes_default_value','attributesDefaultValue']),
      },
    });
  },
  // 删除
  onDel(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/delete_form`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 重命名
  checkName(data: Record<string, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 查询注册表单
  getFormsState(data?: Record<any, any>) {
    return http.post(`${MODEL}/get_state`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
